import { Group, Paper, Stack, Text, Title } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { LoadOrError } from "../../../components/LoadOrError/LoadOrError";
import { LoadingLines } from "./LoadingTile";

interface MiniTileItem {
  label: string;
  value: React.ReactNode;
}

interface MiniTileProps {
  title: string | React.ReactNode;
  subTitle?: string;
  icon: React.ReactNode;
  iconColor?: string;
  items: Array<MiniTileItem>;
  isLoading?: boolean;
  error?: Error | null;
}

function MiniTile({
  title,
  icon,
  iconColor,
  items,
  isLoading,
  error
}: MiniTileProps) {
  return (
    <Paper className="MiniTile" mih={130} miw={250}>
      <Stack h="100%" justify="space-between">
        <Group
          align="start"
          className="mini-tile-header"
          gap="xs"
          justify="space-between"
          wrap="nowrap"
        >
          <Title order={6} size="h4">
            {title}
          </Title>
          {error ? (
            <Text c="error" span>
              <IconAlertTriangle />
            </Text>
          ) : (
            <Text c={iconColor || "primary"} span>
              {icon}
            </Text>
          )}
        </Group>
        <LoadOrError
          error={error}
          loading={isLoading}
          loadingComponent={<LoadingLines />}
        >
          <Group gap="sm" wrap="nowrap">
            {items.map((item) => (
              <Stack gap="xs" key={item.label}>
                <Text span>{item.label}</Text>
                <Text fw={500} fz="h4" span style={{ whiteSpace: "nowrap" }}>
                  {item.value}
                </Text>
              </Stack>
            ))}
          </Group>
        </LoadOrError>
      </Stack>
    </Paper>
  );
}

export { MiniTile, MiniTileItem, MiniTileProps };
